import { render, staticRenderFns } from "./KibanaLinks.vue?vue&type=template&id=17f6f92b"
import script from "./KibanaLinks.vue?vue&type=script&lang=ts"
export * from "./KibanaLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports